import { ComparisonOperator, Field, FieldType } from "../../vforms-model";
import { SelectionList } from "../selection-list";
import { SingleSelectionDropdownComponent } from "../single-selection-dropdown/single-selection-dropdown.component";
import { SingleSelectionDropdownEditorComponent } from "../single-selection-dropdown/single-selection-dropdown-editor.component";
import { ComparisonExpression } from "../../expression-settings/model";

export class MultipleSelectionDropdownType extends FieldType {
    static Id = "multiple-selection-dropdown";

    constructor() {
        super();
        this.id = MultipleSelectionDropdownType.Id;
        this.icon = "mat_outline:checklist";
        this.previewComponent = SingleSelectionDropdownComponent;
        this.editorComponent = SingleSelectionDropdownEditorComponent;
    }

    createField(): Field {
        return new SelectionList(this);
    }

    supportedComparisonOperators(): ComparisonOperator[] {
        return [...super.supportedComparisonOperators(), ComparisonOperator.Contains, ComparisonOperator.NotContains];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        let selection: string[] = value ?? [];
        switch (expression.operator) {
            case ComparisonOperator.Contains:
                return selection.findIndex((i) => i === expression.value) >= 0;
            case ComparisonOperator.NotContains:
                return selection.findIndex((i) => i === expression.value) < 0;
        }

        return super.evaluate(expression, value);
    }
}
